import{jsxs as e,jsx as n}from"react/jsx-runtime";import{Fonts as t}from"@vds-core/typography";import{calculateRem as i,withVDSManager as o}from"@vds-core/utilities";import{AccessibilityTokens as r}from"@vds-tokens/accessibility";import{ColorTokens as a}from"@vds-tokens/color";import{TypographyTokens as l}from"@vds-tokens/typography";import d from"styled-components";const s=r.color.focusring.onlight.value,u=r.color.focusring.ondark.value,c=l.fontweight.regular.value,f=l.fontweight.bold.value,p=l.lineheight.body[20].value,h=i(44),b=r.focusring.borderwidth.value,g=r.focusring.space.offset.value,v=function(e){return{default:"dark"===e?a.elements.primary.ondark.value:a.elements.primary.onlight.value,hover:"dark"===e?a.elements.primary.ondark.value:a.elements.primary.onlight.value,active:"dark"===e?a.interactive.active.ondark.value:a.interactive.active.onlight.value,disabled:"dark"===e?a.interactive.disabled.ondark.value:a.interactive.disabled.onlight.value}},y=function(e,n){let t="0px";return"large"===e&&"desktop"===n&&(t=l.letterspacing.wide.value),t},m=d.span.withConfig({displayName:"HitArea",componentId:"VDS__sc-2pjk45-0"})`
  box-sizing: content-box;
  cursor: pointer;
  display: inline;
  height: ${function({type:e}){return"inline"===e?"1.2em":h}};
  left: 50%;
  outline: none;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;

  &:hover {
    cursor: pointer;
  }
`,$=d.span.withConfig({displayName:"Wrapper",componentId:"VDS__sc-2pjk45-1"})`
  height: ${function({type:e}){return"inline"===e?"inherit":i(p)}};
  width: 100%;
  position: relative;

  &:focus {
    outline: none;
  }
`,k=d.a.withConfig({displayName:"StyledAnchor",componentId:"VDS__sc-2pjk45-2"})`
  background-image: none;
  place-self: center;
  background-color: transparent;
  border: 0;
  border-bottom: ${function({underline:e}){return e.default}};
  box-sizing: border-box;
  color: ${function({colors:e}){return e.default}};
  cursor: pointer;
  outline: none;
  position: relative;
  text-decoration: none;
  touch-action: manipulation;
  transition: opacity ${"0.15s"} ease-in;
  width: auto;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
  ${function({size:e}){return"large"===e?"padding-bottom: 1px":void 0}};

  ${function({type:e}){return"inline"===e&&"\n    color: inherit;\n    border-color: inherit;\n    font-size: inherit;\n    font-family: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n    letter-spacing: inherit;\n  "}}

  ${function({type:e,bold:n,fontStyles:o,size:r}){return"inline"!==e&&`\n    font-size: ${i(null==o?void 0:o.fontSize)};\n    font-family: ${"large"===r?t.VerizonNHGeDS:t.VerizonNHGeTX};\n    font-weight: ${n?f:c};\n    line-height: ${i(null==o?void 0:o.lineHeight)};\n    letter-spacing: ${i(null==o?void 0:o.letterSpacing)};\n  `}}
  outline: none;
  &:focus:not(:hover) ${$} {
    outline: ${function({surface:e}){return function(e="default"){const n="inverted"===e?u:s;return`${i(b)} ${r.focusring.borderstyle.value} ${n}`}("dark"===e?"inverted":"default")}};
    outline-offset: ${i(parseInt(g))};
    border-radius: ${function({focusRingBorderRadius:e}){return e}};
    padding-bottom: 2px; // Padding top & bottom required to fix the focus ring height
    padding-top: 1px;
  }
  &:focus:not(:hover):not(:focus-visible) {
    &:after {
      display: none; // Only display focus state on keyboard focus, not when radio button is clicked
    }
  }
  &:hover {
    color: ${function({colors:e}){return e.hover}};
    border-bottom: ${function({underline:e}){return e.hover}};
  }

  &:active {
    color: ${function({colors:e}){return e.active}};
    border-bottom: ${function({underline:e}){return e.active}};
  }

  ${function({disabled:e,colors:n,underline:t}){return e&&`\n    border-bottom: ${t.disabled};\n    color: ${n.disabled};\n    pointer-events: none;\n  `}};
`,x=function(e){return"small"===e?l.fontsize.body[12].value:l.fontsize.body[16].value},w=function(e){return"small"===e?l.lineheight.body[16].value:l.lineheight.body[20].value},z=function(e,n,t){const i="inline"===e;return{fontSize:i?"inherit":x(t),lineHeight:i?"inherit":w(t),letterSpacing:i?"inherit":y(t,n)}},S=function(t){const{id:o,disabled:r,dataLoc:a,tabIndex:l,role:d,surface:s,viewport:u,focusRingBorderRadius:c,onClick:f}=t;let p=t.ariaLabel?t.ariaLabel:t.children&&"string"==typeof t.children?t.children:"Text Link";const h=v(s),b=function(e){const n=v(e);return{default:`${i(1)} solid ${n.default}`,hover:`${i(2)} solid ${n.hover}`,active:`${i(2)} solid ${n.active}`,disabled:`${i(1)} solid ${n.disabled}`}}(s),g="tablet"===u?"desktop":u;return e(k,Object.assign({},t,{onClick:function(e){let n=e;if(n.target=e.currentTarget,f)return f(n)},id:o,type:t.type,disabled:r,surface:s,href:t.href,bold:t.bold,"aria-label":p,role:d,"aria-disabled":t.disabled,tabIndex:t.disabled?-1:l||0,"data-loc":a,fontStyles:z(t.type,g,t.size),colors:h,underline:b,focusRingBorderRadius:c,onKeyDown:function(e){t.onKeyDown&&t.onKeyDown(e),"Enter"!==e.key&&" "!==e.key||t.onClick&&t.onClick(e)},children:[n(m,{type:t.type,tabIndex:-1,"aria-hidden":!0}),n($,{tabIndex:-1,"aria-hidden":!0,type:t.type,children:t.children})]}))};S.defaultProps={size:"large",viewport:"desktop",type:"inline",disabled:!1,surface:"light",onClick:function(){},bold:!1,tabIndex:0,role:"link",focusRingBorderRadius:"2px"};var I=o(S);export{I as default};
